import { Avatar, } from 'antd';
import Gravatar from 'react-gravatar';

const ProfileImage = ({
    image = undefined,
    email,
    size,
}) => {

    return (
        <>
            {image ? (
                <Avatar
                    size={size || 50}
                    src={image}
                />) : (
                <Avatar
                    // size={size ? 45 : { xs: 24, sm: 32, md: 45, lg: 74, xl: 100, xxl: 120 }}
                    size={size || 50}
                    className="rounded-full gravatar"
                    icon={
                        <Gravatar
                            email={email || ''}
                            // default="blank"
                            default={`${process.env.REACT_APP_WEBSITE}/images/user-thin.png`} />}
                />
            )}
        </>
    );
};

export default ProfileImage;